export default {
  club_name: 'FBC Kalmarsund',
  club_name_short: 'fbc',
  stadium_name: '',
  staging_url: 'https://fbc.api.fangroup.io',
  prod_url: 'https://fbc.api.fangroup.io',
  api: '/api',
  facebook: '',
  basename: '/fbc',
  club_logo: '/assets/teams/fbc.png',
  app_name: 'fbc',
  websale_name: 'fbc',
  ntb_team_id: 10038,
  microservice_url: 'https://stats.api.fangroup.io',
  currencyCaps: 'SEK',
  currencyShort: 'Kr',
  currencyShortSmall: 'kr',
  clubSportalityAvailable: false,
  leagueSportalityAvailable: false,
  cloudIdName: 'fbc',
  monolithEnabled: false,
};
